

        jQuery(function() {
            var $module = jQuery('#m-1526300866298').children('.module');
            $module.find('.counter').counterUp({
                delay: 10,
                time: 1000
            });
        });
    
        jQuery(function() {
            var $module = jQuery('#m-1526300992052').children('.module');

        }); 
    